<script setup lang="ts">
import { cn } from '@/utils/RandomUtils.ts';
import { DropdownMenuSeparator, type DropdownMenuSeparatorProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<
    DropdownMenuSeparatorProps & {
        class?: HTMLAttributes['class'];
    }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <DropdownMenuSeparator
        v-bind="delegatedProps"
        :class="cn('-mx-1 my-1 h-px bg-zinc-100 dark:bg-zinc-800', props.class)"
    />
</template>
